import React from 'react';
import { MessageCircle, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { useSupport } from '../context/SupportContext';

function SupportNotificationBanner() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { enabled, banner, dismissBanner, writesBlocked } = useSupport();

  if (!enabled || !banner) return null;

  const fromSupport = banner.authorType === 'support';
  const title = fromSupport
    ? 'New reply from CarWashMinder'
    : 'New activity on a support request';

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        backgroundColor: theme.palette.mode === 'dark' ? '#172554' : '#eff6ff',
        color: theme.palette.mode === 'dark' ? '#dbeafe' : '#1e3a8a',
        borderBottom: `1px solid ${theme.palette.mode === 'dark' ? '#1e40af' : '#bfdbfe'}`,
        padding: '10px 20px'
      }}
    >
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '16px',
        flexWrap: 'wrap',
        textAlign: 'left'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', minWidth: 0, flex: 1 }}>
          <MessageCircle size={20} aria-hidden="true" />
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: '14px', fontWeight: 700 }}>{title}</div>
            <div style={{ fontSize: '13px', lineHeight: 1.4, overflowWrap: 'anywhere' }}>
              <strong>{banner.subject}</strong>
              {banner.preview ? ` — ${banner.preview}` : ''}
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <button
            type="button"
            onClick={() => navigate(`/support?request=${encodeURIComponent(banner.requestId)}`)}
            style={{
              border: 'none',
              borderRadius: '8px',
              backgroundColor: theme.palette.primary.main,
              color: '#fff',
              padding: '8px 13px',
              minHeight: '36px',
              fontWeight: 700,
              cursor: 'pointer'
            }}
          >
            View Reply
          </button>
          {!writesBlocked && (
            <button
              type="button"
              onClick={dismissBanner}
              aria-label="Dismiss support notification"
              title="Dismiss"
              style={{
                border: 'none',
                background: 'transparent',
                color: 'inherit',
                width: '36px',
                height: '36px',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                borderRadius: '8px'
              }}
            >
              <X size={18} aria-hidden="true" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default SupportNotificationBanner;
